import { type FC } from 'react';
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import OrganizeIcon from 'dibs-icons/exports/legacy/Organize';

import styles from './NftProfileCollectionNavImportCta.scss';

export const NftProfileCollectionNavImportCta: FC<{ onClick: () => void }> = ({ onClick }) => (
    <Link className={styles.link} onClick={onClick} buyerLinkType="linkNoDecoration">
        <OrganizeIcon className={styles.icon} />
        <FormattedMessage
            id="nftProfile.collectionNavImportCta.cta"
            defaultMessage="Import Collection"
        />
    </Link>
);
